module.exports = __webpack_public_path__ + "img/中国卫星导航定位协会@2x.d3b843ca.png";